<template>
    <div>
        <el-card>
            <div slot="header">
                <router-link  :to="{ path:'/changeDirMes',query: { callback:getList } }">
                    <el-button type="primary">新增</el-button>
                </router-link>
            </div>
            <el-table 
                :data="tableData" 
                row-key="id" 
                lazy 
                :load="load" 
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column type="index" width="50"/>
                <el-table-column label="类型名称" prop="title"></el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/changeDirMes',
                            query: { message:scope.row,type:'edit',callback:getList }}">
                            <el-button type="text" >编辑</el-button>
                        </router-link>
                        <el-button v-w-role="'ITSM-0069'" class="table-del-btn" type="text" @click="deleteRole(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination 
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.pageIndex"
                :page-sizes="[10,20]"
                :page-size="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>

    import services from "./event.service"
    export default {
        data: function () {
            return {
                form: {//表单信息
                    pageIndex:1,
                    pageSize:10
                },
                loading:true,
                total:5,//总条数
                tableData:[],//列表信息
            }
        },
        created(){
            this.getList();
        },
        methods:{
            getList(){//请求列表信息
                services.getDirectoryList({"parentId":'0',"pageIndex":this.form.pageIndex,"pageSize":this.form.pageSize}).then(res => {
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            deleteRole(id){//删除信息
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.delDirectory({"id":id}).then(res => {
                        this.$message.success("成功删除!");
                        this.getList();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.getList()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.getList();
            },
            load(tree, treeNode, resolve) {//加载子集
                services.getDirectoryList({"parentId":tree.id,"pageIndex":this.form.pageIndex,"pageSize":this.form.pageSize}).then(res => {
                    resolve(res.list);
                })
            }
        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    
</style>